module.exports = __webpack_public_path__ + "static/sms_background-bd24524ffe820d6cd4ea7835ff135b60.jpeg";